import React from "react";
import { AppBar, Toolbar, Typography, Avatar, Box } from "@mui/material";
import CatLoginIcon from "../../assets/icons/CatLoginIcon.png";
function Navbar() {
  return (
    <AppBar
      position="fixed"
      elevation={0} // Keep it flat or minimal
      sx={{
        backgroundColor: "#fff",
        color: "#333",
        height: "91px",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        borderBottom: "1px solid #e0e0e0",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          height: "100%", // Take full height of AppBar
          alignItems: "center", // Center items vertically
        }}
      >
        {/* Left side */}
        {/* <Typography variant="h6" sx={{ fontWeight: "bold" }}></Typography> */}

        {/* Right side */}
        <Avatar
          alt="User"
          src={CatLoginIcon}
          sx={{
            height: "50px",
            width: "50px",
          }}
        />
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
